module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_1-f05244a9d825cce30019990f3e3cad0b.jpg";